var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditorNodeWrapper',{class:[
    'node-container',
    _vm.rowTypeClass,
    _vm.blockWidthClass,
    {
      'parent-first-child': _vm.parentFirstChild,
      'parent-last-child': _vm.parentLastChild,
    } ]},[(_vm.isResourcePlaceholder)?_c('ResourcePlaceholder',{attrs:{"node":_vm.node,"placeholder":_vm.placeholder}}):_c('ElementPlaceholder',{attrs:{"node":_vm.node}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }